import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getMechanicsTacticsDropDownValues, getPortfolioAnalysisBubbleChartData } from 'gqlQueries/portfolioAnalysis';
import { UserContext } from 'contexts/ConfigContext';
import _, { uniq } from 'lodash';
import { bubbleChartDriverParser } from 'parser/portfolioAnalysisParser';

const errorMessage: string = 'Something went wrong!';
function useFetchMechanicsTacticsData() {
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [loading, setLoading] = useState(false);
    const { appConfig: config } = useContext(UserContext);
    const { portfolioAnalysis } = config;
    const promoTypesLabelMapping: any = portfolioAnalysis.promoTypesLabelMapping;
    const [fetchMechanicsTacticsDropDownValues] = useLazyQuery(getMechanicsTacticsDropDownValues, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getMechanicsTacticsListData } = payload;
            //if data present parse it
            if (
                getMechanicsTacticsListData &&
                'mechanicsList' in getMechanicsTacticsListData &&
                'tacticsList' in getMechanicsTacticsListData
            ) {
                const parsedMechanicsData = getMechanicsTacticsListData['mechanicsList']
                    ?.filter((item: any) => item !== null)
                    .map((item: string) => {
                        return {
                            key: item,
                            label: item,
                            selected: true,
                        };
                    });
                const parsedTacticsData = getMechanicsTacticsListData['tacticsList'].map((item: string) => {
                    return {
                        key: item,
                        label: item in promoTypesLabelMapping ? promoTypesLabelMapping[item] : item,
                        selected: true,
                    };
                });
                setData({ Mechanics: parsedMechanicsData, Tactic: parsedTacticsData });
                return;
            }
            setData(null);
        } catch (error: any) {
            onFetchComplete(error);
            console.error(errorMessage, error, 'logging error');
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        console.log('logging error', error);
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        error,
        data,
        loading,
        fetchMechanicsTacticsDropDownValues: (variables: any) => {
            setLoading(true);
            setError(null);
            fetchMechanicsTacticsDropDownValues(variables);
        },
    };
}

export { useFetchMechanicsTacticsData };
